export const SELECTORS = {
  CONTAINER: 'js-clipboard-copy-container',
  COPY_ELEM: 'js-clipboard-copy',
  COPIED_ELEM: 'js-clipboard-copied'
};
